import { styled } from "styled-components";

export const StyledCadenceList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(50% - 6px), 1fr));
    gap: 12px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0 12px 0 0;
    scrollbar-width: 12px;

    > * {
        min-width: 0;
    }
`;
